<template>
    <div class="orderinfo_page">
        <div class="order-modal" v-if="isShow" @touchmove.prevent>
            <div class="complain" v-if="actionType == 'complain'">
                <img src="../assets/images/popup_close@3x.png" @click="cancelComplain">
                <h2>投诉工程师</h2>
                <div class="form">
                    <div class="title">问题描述</div>
                    <textarea v-model="content"></textarea>
                    <div v-if="content!=''" class="submit" @click="submitComplaint">提交</div>
                    <div v-if="content==''" class="submit disabled">提交</div>
                </div>
            </div>

            <div class="arrange-info" v-if="actionType=='arrange'" :class="{'open':sheetAction}">
                <div class="title">
                    <img class="close" src="../assets/images/popup_close@3x.png" @click="closeSheet">
                    <p>工程师班表</p>
                    <span>{{order.engineer.eng_no}}号工程师最近7天在线服务时间</span>
                </div>
                <div class="arrange-wrapper">
                    <ul class="arrange-list">
                        <li v-for="item in arrangement" :key="item.date">
                            <span class="date">{{item.date | dateFormat}}（{{item.date | weekFormat}}）</span>
                            <span class="time">{{item.arrangement}}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <ul class="contact-sheet" :class="{'close':contactSheet}">
                <li @click="openQiyu">在线即时沟通（推荐）</li>
                <li>企业QQ沟通</li>
                <li @click="cancelContact">关闭</li>
            </ul>
        </div>

        <div class="main-wrapper">
            <mt-header fixed title="订单详情" style="background:#3189FF;color:#ffffff;">
                <router-link to="/orderList" slot="left">
                <mt-button icon="back"></mt-button>
                </router-link>
                <mt-button slot=right>
                    <a :href="'tel:'+tel_400">
                        <img src="../assets/images/order_phone@3x.png" class="head-phone-icon">
                    </a>
                </mt-button>
            </mt-header>

            <div class="scroll-wrapper">
                <div class="scroll-content">
                    <div class="order_wrapper">
                        <div class="order-progress_wrapper">
                            <div class="order_status">
                                <div class="icon" :class="iconClass"></div>
                                <div class="order_msg" v-if="order.status == 3">
                                    <p>{{order.service.title}}</p>
                                    <span>{{order.service.tips}}</span>
                                </div>
                                <div class="order_msg" v-if="order.status==2">
                                    <p>订单未支付</p>
                                    <span>数据丢失，越早恢复越好</span>
                                </div>
                                <div class="order_msg" v-if="order.status==1">
                                    <p>订单已取消</p>
                                    <span>很抱歉，您的订单已取消</span>
                                </div>
                            </div>
                            <div class="order_progress">
                                <div class="progress">
                                    <p class="ball" :class="{'selected':order.service && order.service.status == 2}"><span class="select"></span></p>
                                    <p class="line"></p>
                                    <p class="ball" :class="{'selected':order.service && order.service.status == 3}"><span class="select"></span></p>
                                    <p class="line"></p>
                                    <p class="ball" :class="{'selected':order.service && order.service.status == 4}"><span class="select"></span></p>
                                    <p class="line"></p>
                                    <p class="ball" :class="{'selected':order.service && order.service.status == 5}"><span class="select"></span></p>
                                    <p class="line"></p>
                                    <p class="ball" :class="{'selected':order.service && order.service.status == 6 || order.service && order.service.status == 7}"><span class="select"></span></p>
                                </div>
                                <div class="progress_text">
                                    <span :class="{'selected':order.service && order.service.status == 2}">订单已提交</span>
                                    <span :class="{'selected':order.service && order.service.status == 3}">派单成功</span>
                                    <span :class="{'selected':order.service && order.service.status == 4}">预约成功</span>
                                    <span :class="{'selected':order.service && order.service.status == 5}">服务中</span>
                                    <span :class="{'selected':order.service && order.service.status == 6 || order.service && order.service.status == 7}">服务完成</span>
                                
                                </div>
                            </div>
                        
                        </div>
                        <div class="order-msg" v-if="messageList.length>0">
                            <div class="msg-box" @click="goOrderHistory">
                                <span>
                                    <img class="tip" src="../assets/images/order_message@3x.png">
                                    {{messageList[0].subject}}
                                </span>
                                <img class="arrow" src="../assets/images/global_more_arrow@3x.png">
                            </div>
                        </div>
                        <div class="order_info grayBar">
                            <div class="order_title">
                                <span class="title_ball"></span>
                                <p class="order_no">订单：{{order.orderno}}</p>
                                <span class="pay_status" v-if="order.refund_status == -1" :class="{'pay':order.status==3,'nopay':order.status==2,'cancel':order.status==1}">{{order.status | payStatus}}</span>
                                <span class="pay_status cancel" v-if="order.refund_status != -1" >{{order.refund_text}}</span>
                            </div>
                            <ul class="order_content">
                                <li>
                                    <span>服务项目</span>
                                    <p>{{order.detail?order.detail[0].g_description:''}}</p>
                                </li>
                                <li>
                                    <span>套餐类型</span>
                                    <p>{{order.detail?order.detail[0].gm_name:''}}</p>
                                </li>
                                <li>
                                    <span>创建时间</span>
                                    <p>{{order.detail?order.detail[0].ctime:'' | timestampToTime}}</p>
                                </li>
                                <li>
                                    <span>付款金额</span>
                                    <p>¥ {{order.total}}</p>
                                </li>
                            </ul>
                        </div>

                        <ul class="service-info_wrapper" v-if="service_orders.length">
                            <li class="ser_items grayBar">
                                <div class="order_title">
                                    <span class="title_ball"></span>
                                    <p class="header">服务信息</p>
                                    <span class="pay_status" :class="{'pay':service_order.status ==3,'nopay':service_order.status ==2}">{{service_order.status | serStatus}}</span>
                                </div>
                                <div class="service_info">
                                    <ul class="service_detail">
                                        <li><span class="label">服务名称</span><span class="no">{{service_order.title}}</span></li>
                                        <li><span class="label">服务费用</span><span class="money">¥ {{service_order.total}}</span></li>
                                        <li><span class="label">服务方案</span><span>{{service_order.remark}}</span></li>
                                        <li><span class="label"><i style="opacity: 0;">空</i>优惠券</span>
                                            <span class="none" v-if="!service_order.discount"><span></span><span>无可用</span> </span>
                                            <span class="coupon" v-if="service_order.discount">
                                                已使用1张<span>-¥ {{service_order.discount}}</span>
                                            </span>
                                        </li>
                                        <li div class="payMoney">
                                            <span>
                                                <span><i style="opacity: 0;">空</i>总计<i style="opacity: 0;">空</i></span><span class="cost">￥{{service_order.total}}</span>
                                            </span>
                                            <button class="service_pay" v-if="service_order.status == 2" @click="goPay_svr(service_order.sorder_no,service_order.total,service_order.creason,order.orderno)">去支付</button>
                                        </li>
                                        <li div class="check-more" v-if="service_orders.length>1" @click="checkMoreInfo">
                                            查看更多内容
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>

                        <div class="engineer-info_wrapper grayBar" v-if="order.service && order.service.status>2">
                            <div class="order_title">
                                <span class="name">
                                    <span class="title_ball"></span>
                                    <p class="header">工程师信息</p>
                                </span>
                                <span class="complain" @click="complainEng">投诉工程师</span>
                            </div>
                            <div class="engineer_info">
                                <ul class="engineer_detail">
                                    <li>
                                        <span>
                                            <span class="label">工程师工号</span><span class="no">{{order.engineer.eng_no}}</span>
                                        </span> 
                                        <span class="arrange" @click="checkArrangement" v-if="order.engineer.eng_no">
                                            查看排班
                                            <img class="arrow" src="../assets/images/global_more_arrow@3x.png">
                                        </span>
                                    </li>
                                    <li>
                                        <span style="display:flex;">
                                            <span class="label">工程师QQ</span>
                                            <span style="display: inline-block">
                                                <a class="qq" target="_blank" :href="'http://wpa.qq.com/msgrd?v=3&uin='+order.engineer.qq+'&site=qq&menu=yes'">{{order.engineer.qq}}</a><br/>
                                                <span style="display:inline-block;margin-top:12px;color:#FF001F;font-size:12px">点击上方QQ号可及时联系工程师</span>
                                            </span>
                                        </span> 
                                        
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="tips_wrapper" :class="order.status == 3 ? 'grayBar' : ''">
                            <div class="order_title">
                                <span class="title_ball"></span>
                                <p class="header">温馨提示</p>
                            </div>
                            <div class="tips"  v-if="order.status == 3">
                            {{order.service.summary}}
                            </div>
                            <div class="tips"  v-if="order.status == 2">
                            手机数据丢失后要特别小心使用手机，数据随时可能被损坏导致不能恢复，越早恢复效果越好，强烈建议您尽快完成支付。
                            </div>
                            <div class="tips"  v-if="order.status == 1">
                            很抱歉，您的订单已取消。如有任何问题，请拨打客服热线4008003086，我们将在最短的时间内为您解决问题。
                            祝您生活愉快。
                            </div>
                        </div> 

                        <div class="tips_wrapper" v-show="order.status == 3">
                            <div class="order_title">
                                <span class="title_ball"></span>
                                <p class="header">联系我们</p>
                            </div>
                            <ul class="corp-info">
                                <li>
                                    <span class="label">联系电话</span>
                                    <span class="phone"><a :href="'tel:'+tel_400">{{tel_400}}</a></span>
                                </li>
                            </ul>
                        </div> 
                    </div>
                </div>
            </div>

            <div class="contact-eng" v-if="order.status >= 3 && order.service.status < 6 && allow_chat == 1">
                <div class="btn" @click="contactEngineer">
                    联系工程师
                </div>
            </div>
    
            <div class="purchase-wrapper" v-if="order.status == 2">
                <div class="purchase-wrapper_fixed">
                    <span class="fee">共计：<span class="money">¥{{order.total}}</span></span>
                    <button class="order_now" @click="goPay(order.orderno)">立即支付</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Loadmore,Indicator } from 'mint-ui';
import _ from 'lodash';
import moment from 'moment'

export default {
    name:"orderinfo",
    metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
        return{
            order:{},
            allLoaded:false,
            iconClass:"",
            wrapperHeight:0,
            clientH :0,
            service_orders:[],
            isShow: false,
            content: '',
            service_order: {},
            tel_400: '',
            arrangement: [],
            actionType: 'complain',
            sheetAction: false,
            contactSheet: true,
            allow_chat: 0,
            orderno: '',
            messageList: []
        }
    },
    methods:{
        getMessages(){
            let access_token = localStorage.access_token
            let data = {
                access_token: access_token,
                info: {
                    app_id: window.config.appid,
                    order_no: this.orderno
                }
            }
            this.$store.dispatch('getMessages',data).then((res)=>{
                let result = res.data
                if(result.code == 0){
                    this.messageList = result.res
                    if(this.messageList.length>0){
                        localStorage.msg_last_id = this.messageList[0].id
                    }
                }
            })
        },
        checkMoreInfo(){
            this.$router.push({name: 'serviceInfo',query:{orderno:this.orderno}})
        },
        goOrderHistory(){
            this.$router.push({name:'orderHistory',query:{orderno: this.orderno}})
        },
        openQiyu(){
          var config = {
            uid: localStorage.kxuid,
            name: localStorage.nickname,
            mobile: localStorage.phone,
            success: function(){     // 成功回调
                ysf.open();
            },
            error: function(){       // 错误回调
                // handle error
            }
          };
          ysf.config(config);
        },
        contactEngineer(){
            let vm = this
            vm.isShow = true
            setTimeout(function(){
                vm.contactSheet = false
            },300)
        },
        cancelContact(){
            let vm = this
            vm.contactSheet = true
            setTimeout(function(){
                vm.isShow = false
            },300)
        },
        closeSheet(){
            let vm = this
            vm.sheetAction = false
            setTimeout(function(){
                vm.isShow = false
            },300)
        },
        checkArrangement(){
            let vm = this
            vm.isShow = true
            vm.actionType = 'arrange'
            setTimeout(function(){
                vm.sheetAction = true
            },300)
        },
        getEngArrangement(){
            let today = new moment().format('YYYY-MM-DD')
            let future = moment(today).add(6,'d').format('YYYY-MM-DD')
            let access_token = localStorage.access_token
            let info = {
                eng_no: this.order.engineer.eng_no,
                date_from: today,
                date_to: future,
                access_token: access_token
            }
            this.$store.dispatch('getEngArrangement',info).then((res)=>{
                let result = res.data
                if(result.code == 0){
                    this.arrangement = result.res
                }
            })
        },
        getSystemConfig(){
            let info = {
                app_id: '30001081'
            }
            this.$store.dispatch('getSystemConfig',info).then((res)=>{
                if(res.data.code===0){
                    this.tel_400 = res.data.res.tel_400[0]
                }
            })
        },
        submitComplaint(){
            let access_token = localStorage.access_token
            let data = {
                info: {
                    type: 4,
                    content: this.content,
                    app_id: window.config.appid,
                    tags: '41'
                },
                access_token: access_token
            }
            this.$store.dispatch('feedback',data).then((res)=>{
                let result = res.data
                if(result.code == 0){
                    this.cancelComplain()
                    this.$router.push({name:'suggestion_next',query:{feedback_id:result.res.feedback_id,nextPath:'orderDetail'}})
                }
            })
        },
        complainEng(){
            this.isShow = true
            this.actionType = 'complain'
        },
        cancelComplain(){
            this.isShow = false
        },
        goback(){
            this.$router.push({name:"orderList"})
        },
        loadTop() {
            this.getOrderDetail();
            this.$refs.loadmore.onTopLoaded();
        },
    
       getOrderDetail(){
            let access_token = localStorage.access_token;
            if(!this.orderno){
                this.$router.replace({name:"orderList"});
                return
            }
            let info = {
                access_token:access_token,
                orderno:this.orderno
            }
            let vm = this;
            Indicator.open('加载中');
            this.$store.dispatch("getOdinfo",info).then((res)=>{
                Indicator.close();
               
                var data = res.data;
                if(data.code == 0){
                    vm.order = data.res.order;
                    var order = vm.order;
                    vm.getEngArrangement()
                    if(order.service && order.service.service_orders){
                        vm.service_orders = order.service.service_orders.reverse();
                        vm.service_order = _.find(vm.service_orders,(o)=>{
                            return o.status == '2'
                        })
                        if(!vm.service_order && order.service.service_orders.length>0){
                            vm.service_order = vm.service_orders[0]
                        }
                    }
                    if(order.status == 1){
                        vm.iconClass = 'cancel';
                    }else if(order.status == 2){
                        vm.iconClass = 'wait';
                    }else {
                        if(order.service.status == 2){
                            vm.iconClass = 'paid'
                        }else if(order.service.status == 3){
                            vm.iconClass = 'assigned';
                        }else if(order.service.status == 4){
                            vm.iconClass = 'order';
                        }else if(order.service.status == 5){
                            vm.iconClass = 'serIng';
                        }else if(order.service.status == 6){
                            vm.iconClass = 'finish';
                        }else if(order.service.status == 7){
                            vm.iconClass = 'finish';
                        }
                    }
                }else if(data.code == 1200){
                     new Promise(vm.refreshToken).then(function(token){
                         info.access_token = token;
                         vm.$store.dispatch("getOdinfo",info).then((res)=>{
                            var data = res.data;
                            if(data.code == 0){
                                vm.order = data.res.order;
                                if(order.service.status == 2){
                                    vm.iconClass = 'submit';
                                }else if(order.service.status == 3){
                                    vm.iconClass = 'dispach';
                                }else if(order.service.status == 4){
                                    vm.iconClass = 'order';
                                }else if(order.service.status == 5){
                                    vm.iconClass = 'serIng';
                                }else if(order.service.status == 6){
                                    vm.iconClass = 'finish';
                                }else if(order.service.status == 7){
                                    vm.iconClass = 'finish';
                                }
                            }else{
                                vm.$router.push({name:"login"})
                            }
                         })
                     })
                   
                }else if(data.code == 1201){
                    vm.$router.push({name:"login"})
                }
                setTimeout(function(){
                    Indicator.close();
                },300)
            })
       },
       goPay(orderno){
            this.$router.push({name:"pay",query:{
                'orderno':orderno
            }})
       },
       goPay_svr(sorder_no,price,remark,orderno){
            this.$router.push({name:"pay",query:{
                'orderno':orderno,
                'sorder_no':sorder_no,
                'price':price,
                'g_description': this.order.detail[0].g_description,
                'gm_name': this.service_order.title
            }})
       }
    },
    created(){
        if(this.validToken()){
            this.allow_chat = this.$route.query.allow_chat
            this.orderno = this.$route.query.orderno
            this.getOrderDetail()
            this.getSystemConfig()
            this.getMessages()
        }
    },
    mounted(){
        

    },
    components:{
        Loadmore
    },
    filters:{
        payStatus(val){
            if(val == 1){
                return '订单取消'
            }
            if(val == 2){
                return '未支付'
            }
            if(val == 3){
                return '支付完成'
            }
        },
        serStatus(val){
            if(val == 0){
                return '已作废'
            }
            if(val == 1){
                return '已取消'
            }
            if(val == 2){
                return '未支付'
            }
            if(val == 3){
                return '支付完成'
            }
        },
        orderStatus(val){
        
            if(val == 2){
                return '支付完成，等待派单'
            }
            if(val == 3){
                return '已经为您分配工程师'
            }
            if(val == 4){
                return '您已约定服务时间'
            }
            if(val == 5){
                return '工程师正在为你服务'
            }
            if(val == 6){
                return '为您的服务已完成'
            }
            if(val == 7){
                return '为您的服务已完成'
            }
        },
        timestampToTime(timestamp) {
            var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let  Y = date.getFullYear() + '-';
            let  M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            let  D = date.getDate() + ' ';
            let  h = date.getHours() + ':';
            let  m = date.getMinutes() + ':';
            let  s = date.getSeconds();
            return Y+M+D+h+m+s;
        },
        dateFormat(val){
            return moment(val).format('YYYY年M月D日')
        },
        weekFormat(val){
            let index = moment(val).format('d')
            let arr = ['周日','周一','周二','周三','周四','周五','周六']
            let today = new moment().format('YYYY-MM-DD')
            if(val == today){
                return '今天'
            }else {
                return arr[index]
            }
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/OrderDetail.vue